/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MetaDataFromJSON, MetaDataToJSON, } from './MetaData';
import { PageRequestFromJSON, PageRequestToJSON, } from './PageRequest';
import { PlayerListEntryFromJSON, PlayerListEntryToJSON, } from './PlayerListEntry';
/**
 * Check if a given object implements the PagedResponseOfPlayerListEntry interface.
 */
export function instanceOfPagedResponseOfPlayerListEntry(value) {
    var isInstance = true;
    return isInstance;
}
export function PagedResponseOfPlayerListEntryFromJSON(json) {
    return PagedResponseOfPlayerListEntryFromJSONTyped(json, false);
}
export function PagedResponseOfPlayerListEntryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'entries': !exists(json, 'entries') ? undefined : (json['entries'].map(PlayerListEntryFromJSON)),
        'page': !exists(json, 'page') ? undefined : json['page'],
        'previousPage': !exists(json, 'previousPage') ? undefined : PageRequestFromJSON(json['previousPage']),
        'metaData': !exists(json, 'metaData') ? undefined : MetaDataFromJSON(json['metaData']),
        'hasPrevious': !exists(json, 'hasPrevious') ? undefined : json['hasPrevious'],
        'size': !exists(json, 'size') ? undefined : json['size'],
        'hasNext': !exists(json, 'hasNext') ? undefined : json['hasNext'],
        'numberOfElements': !exists(json, 'numberOfElements') ? undefined : json['numberOfElements'],
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements'],
        'nextPage': !exists(json, 'nextPage') ? undefined : PageRequestFromJSON(json['nextPage'])
    };
}
export function PagedResponseOfPlayerListEntryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'entries': value.entries === undefined ? undefined : (value.entries.map(PlayerListEntryToJSON)),
        'page': value.page,
        'previousPage': PageRequestToJSON(value.previousPage),
        'metaData': MetaDataToJSON(value.metaData),
        'hasPrevious': value.hasPrevious,
        'size': value.size,
        'hasNext': value.hasNext,
        'numberOfElements': value.numberOfElements,
        'totalElements': value.totalElements,
        'nextPage': PageRequestToJSON(value.nextPage)
    };
}
